const ExcelJS = require('exceljs');

async function exportToExcelMinhasSolicitacoes(requests) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Minhas Solicitações');

    // Definindo cabeçalhos
    const headers = [
        'UF',
        'ID Requisição',
        'Solicitante',
        'Empresa Solicitante',
        'GMO',
        'Cód. SAP',
        'Equipamento',
        'Fabricante',
        'Quantidade Solicitada',
        'Quantidade Atender',
        'Quantidade Cortada',
        'Resta Coletar',
        'Tipo Atendimento',
        'Data Abertura',
        'Data SLA',
        'Status',
        'DRS Atender',
        'Observação'
    ];

    worksheet.addRow(headers);

    // Adicionando dados das requests
    requests.forEach(request => {
        // Formatar datas
        const formattedCreatedAt = new Date(request.createdAt).toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        }).replace(', ', ' ');

        const formattedSlaDate = request.slaDate ? new Date(request.slaDate).toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        }).replace(', ', ' ') : '';

        const rowData = [
            request.uf,
            request.idRequest,
            request.nomeSolicitante,
            request.empresaSolicitante,
            request.gmo.cidade + '-' + request.gmo.uf,
            request.codSap,
            request.nomeEquipamento,
            request.fabricanteEquipamento,
            request.quantidadeSolicitada,
            request.quantidadeAtender,
            request.quantidadeCortada,
            request.reverses?.quantidadeRestante,
            request.tipoAtendimento,
            formattedCreatedAt,
            formattedSlaDate,
            request.status,
            request.drsAtender?.sigla || '',
            request.observacao || ''
        ];
        worksheet.addRow(rowData);
    });

    // Salvar o arquivo Excel
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'minhas_solicitacoes.xlsx';
    a.click();
    window.URL.revokeObjectURL(url);
}

export default exportToExcelMinhasSolicitacoes;
